import { Component, Input, OnInit } from '@angular/core';
import { DashboardService } from '../Dashboad.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-learn-next',
  templateUrl: './learn-next.component.html',
  styleUrls: ['./learn-next.component.css']
})
export class LearnNextComponent implements OnInit {

  @Input() nextLearnings: any[] = [];
  constructor(private service: DashboardService, private router: Router) { }

  ngOnInit() {
  }

  goToAllNextLearnings() {
    this.router.navigateByUrl('Home/employee-career/employee-Career-program', { state: { activeTab: 1 } });
  }

  goToPrograms(program) {
    this.router.navigateByUrl('Home/Dashboard/Program Description/' + program.programID, { state: { prevUrl: 'Home/Dashboard' } });
  }
}
